const locale = {
	// #region Chronology fields
	DETAILS_CHRONOLOGY_FIELD_TITLE: 'Titolo',
	DETAILS_CHRONOLOGY_FIELD_DATE: 'Data',
	DETAILS_CHRONOLOGY_FIELD_COMPANY: 'Azienda',
	DETAILS_CHRONOLOGY_FIELD_STATUS: 'Stato Evento',
	DETAILS_CHRONOLOGY_FIELD_TYPE: 'Tipo Evento',
	DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_CHRONOLOGY_FIELD_GROUP: 'Gruppo',
	DETAILS_CHRONOLOGY_FIELD_WARNING: 'Warning',
	DETAILS_CHRONOLOGY_FIELD_BLOCKED: 'Bloccato',
	DETAILS_CHRONOLOGY_FIELD_TAGS: 'Tag'
	// DETAILS_CHRONOLOGY_FIELD_HOURS: 'Ore impiegate',

	// DETAILS_CHRONOLOGY_STATUSES_FIELD_TITLE: 'Titolo',
	// DETAILS_CHRONOLOGY_STATUSES_FIELD_DESCRIPTION: 'Descrizione',
	// DETAILS_CHRONOLOGY_STATUSES_FIELD_ORDER: 'Ordine',
	// #endregion
};

export default locale;
